import React from 'react'
import FilterMultiDate from "./FilterMultiDate"
import PropTypes from 'prop-types'
import SelectSearch from "./../../../shared/components/SelectSearch"
import {STATUS, STATUS_LOCK} from "./../../constant/index"
import {Button, Input} from "antd";

ReportHubPhoneNumberSearch.propTypes = {
    receptionDateFrom: PropTypes.string,
    receptionDateTo: PropTypes.string,
    onChangeFrom: PropTypes.func,
    onChangeTo: PropTypes.func
}

function ReportHubPhoneNumberSearch(props) {
    const {
        listTelco,
        tenants,
        filters,
        onChangeFilters,
        receptionDateFrom,
        receptionDateTo,
        onChangeFrom,
        onChangeTo,
        fetchListReport
    } = props

    const _handleChangeSelect = (name, value) => {
        onChangeFilters(name, value ? value + '' : '')
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target
        onChangeFilters(name, value)
    }

    const _fetchListReport = () => {
        fetchListReport()
    }

    return (
        <div className="PageFilters">
            <FilterMultiDate
                receptionDateFrom={receptionDateFrom}
                receptionDateTo={receptionDateTo}
                onChangeFrom={onChangeFrom}
                onChangeTo={onChangeTo}
            />
            <div className="itemFilter">
                <SelectSearch
                    name="tenantId"
                    value={filters.tenantId ? parseInt(filters.tenantId) : null}
                    onChange={_handleChangeSelect} label="Khách hàng:"
                    listSelect={tenants}
                />
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label htmlFor="shortPhone">Số ảo</label>
                    <Input
                        id="shortPhone"
                        placeholder="Nhập từ khóa cần tìm"
                        name="shortPhone"
                        value={filters.shortPhone || ''}
                        onChange={_handleChangeInput}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label htmlFor="brandName">Brand name</label>
                    <Input
                        id="brandName"
                        placeholder="Nhập từ khóa cần tìm"
                        name="brandName"
                        value={filters.brandName || ''}
                        onChange={_handleChangeInput}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label htmlFor="brandName">Số điện thoại</label>
                    <Input
                        id="phoneNumber"
                        placeholder="Nhập từ khóa cần tìm"
                        name="phoneNumber"
                        value={filters.phoneNumber || ''}
                        onChange={_handleChangeInput}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <SelectSearch
                    name="telco"
                    value={filters.telco ? parseInt(filters.telco) : null}
                    onChange={_handleChangeSelect} label="Mạng:"
                    listSelect={listTelco}
                />
            </div>
            <div className="itemFilter">
                <SelectSearch
                    name="status"
                    value={filters.status ? parseInt(filters.status) : null}
                    onChange={_handleChangeSelect} label="Trạng thái:"
                    listSelect={STATUS}
                />
            </div>
            <div className="itemFilter">
                <SelectSearch
                    name="statusLock"
                    value={filters.statusLock ? parseInt(filters.statusLock) : null}
                    onChange={_handleChangeSelect} label="Mạng khóa:"
                    listSelect={STATUS_LOCK}
                />
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label htmlFor="source">Nguồn</label>
                    <Input
                        id="source"
                        placeholder="Nhập nguồn cần tìm"
                        name="source"
                        value={filters.source || ''}
                        onChange={_handleChangeInput}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <Button type="primary" style={{marginTop: "27px"}} onClick={_fetchListReport}>Tìm kiếm</Button>
            </div>
        </div>
    )
}

export default ReportHubPhoneNumberSearch
